export const STORAGE = {
    AUTO_MODAL_INFO: 'checkoutAutoModalInfo',
    AUTO_MODAL_OFFER_INFO: 'checkoutAutoOfferModalInfo',
    SURVEY_INFO: 'checkoutSurveyInfo',
};
